<template>
  <div class="page page-login">
    <a href="/" class="logo">
      <img :src="assetPath('logo.svg')" :alt="appName" />
    </a>
    <FormLogin />
    <div class="app__version" v-if="debug">
      v{{ appVersion }}
    </div>
  </div>
</template>

<script>
  import FormLogin from '@/components/forms/FormLogin.vue'
  import { APP_VERSION } from '@/constants.ts'
  import { assetPath } from '@/util'

  export default {
    setup() {
      return {
        assetPath,
        appName: import.meta.env.VITE_APP_NAME,
        appVersion: APP_VERSION,
        debug: !import.meta.env.VITE_ENVIRONMENT?.match(/prod/),
      }
    },
    name: 'page-login',
    components: {
      FormLogin,
    },
  }
</script>

<style lang="scss"></style>
